import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { UPCOMING_INVOICE_ENDPOINT } from './endpoints';

const actions = createActions({
  PAYMENT: {
    GET_UPCOMING_INVOICE: undefined,
    API: {
      GET_UPCOMING_INVOICE: apiResourceActionCreator('upcomingInvoice'),
    },
  },
});

export const apiAction = (authToken) => commonApiActions.authenticated.get(UPCOMING_INVOICE_ENDPOINT, authToken, actions.payment.api.getUpcomingInvoice);

export function* fetchUpcomingInvoice(_) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken));
};

const configuration = {
  name: 'getUpcomingInvoice',
  action: actions,
  sagas: fetchUpcomingInvoice,
  reducers: {
    request: (state, _) => ({
      ...state,
      isFetching: true,
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false,
      upcomingInvoice: action.payload.upcomingInvoice,
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false,
      error: action.payload.error,
    }),
  },
};

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/payment/configurations/getUpcomingInvoice.js